import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-admin-info-dialog',
  templateUrl: './admin-info-dialog.component.html',
  styleUrls: ['./admin-info-dialog.component.css']
})
export class AdminInfoDialogComponent implements OnInit {
  form!: FormGroup;
  _id?: string;
  email?: string;
  firstName?: string;
  lastName?: string;

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<AdminInfoDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data:any) {
      this._id = data._id;
      this.email = data.email;
      this.firstName = data.firstName;
      this.lastName = data.lastName;
    }

  ngOnInit() {
    this.form = this.fb.group({
      _id: [this._id, []],
      email: [this.email, []],
      firstName: [this.firstName, []],
      lastName: [this.lastName, []],
    });
  }

  save() {
      this.dialogRef.close(this.form.value);
  }

  close() {
      this.dialogRef.close();
  }
}
